import { Minus, Plus } from "lucide-react";

const btn =
  "flex h-11 w-11 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-700 transition-[background-color] duration-200 hover:bg-slate-100 disabled:opacity-40";

export const GuestStepper = ({ value, max, min = 0, onChange, testidPrefix = "rsvp-extra-guests" }) => {
  const set = (n) => onChange(Math.max(min, Math.min(max, Number.isNaN(n) ? min : n)));
  return (
    <div className="flex items-center gap-3">
      <button type="button" className={btn} data-testid={`${testidPrefix}-decrement`} disabled={value <= min} onClick={() => set(value - 1)}>
        <Minus className="h-4 w-4" />
      </button>
      <input
        type="number"
        inputMode="numeric"
        min={min}
        max={max}
        value={value}
        onChange={(e) => set(parseInt(e.target.value, 10))}
        data-testid={`${testidPrefix}-input`}
        className="h-11 w-16 rounded-xl border border-slate-200 text-center text-lg font-bold focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
      <button type="button" className={btn} data-testid={`${testidPrefix}-increment`} disabled={value >= max} onClick={() => set(value + 1)}>
        <Plus className="h-4 w-4" />
      </button>
      <span className="text-xs text-slate-500">up to {max}</span>
    </div>
  );
};
